import { render } from "./PostSupplyNews.vue?vue&type=template&id=2831c937&scoped=true"
import script from "./PostSupplyNews.vue?vue&type=script&lang=js"
export * from "./PostSupplyNews.vue?vue&type=script&lang=js"

import "./PostSupplyNews.vue?vue&type=style&index=0&id=2831c937&lang=css"
import "./PostSupplyNews.vue?vue&type=style&index=1&id=2831c937&lang=scss&scoped=true"
import "./PostSupplyNews.vue?vue&type=style&index=2&id=2831c937&lang=scss"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2831c937"]])

export default __exports__